import { Library } from "@googlemaps/js-api-loader";
import { StoreType } from "./enums/stores.enum";

export interface StoreLocation {
  address: string;
  storeName: string;
  open: boolean;
  storeTiming: string;
  openingHours: { hours: number; minutes: number };
  closingHours: { hours: number; minutes: number };
  storeType: StoreType;
  coordinates: Coordinates;
  placeId: string;
  googleMapsLink: string;
  distanceMatrixData?: {
    distance: { text: string; value: number };
    duration: { text: string; value: number };
  };
}

export type Coordinates = {
  lng: number;
  lat: number;
};

export const googleMapsLibraries: Library[] = ["places", "maps"];
export const ShemsiMapMarker = "https://svgshare.com/i/vo5.svg";
export const ShemsiUserMapMarker = "https://svgshare.com/i/vjT.svg";
